import { useEffect } from 'react';
import axios from 'axios';

export default function VisitorTracker() {
    const api = "https://mkbackend-production.up.railway.app"
    
    useEffect(() => {
        const trackVisitor = async () => {
            try {
                // Get or create session ID
                let sessionId = localStorage.getItem('visitorSessionId');
                if (!sessionId) {
                    sessionId = 'visitor_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                    localStorage.setItem('visitorSessionId', sessionId);
                }

                // Track visitor
                await axios.post(`${api}/track`, {
                    sessionId,
                    pageVisited: window.location.pathname,
                    referrer: document.referrer || 'direct'
                });
            } catch (error) {
                console.error('Error tracking visitor:', error);
            }
        };

        trackVisitor();
    }, []);

    return null;
}